import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { FixedSizeList as List } from "react-window";
// import InfiniteLoader from "react-window-infinite-loader";
import { uniqueId } from 'lodash';
import { AutoSizer } from 'react-virtualized';
import { ConversationCardModel } from '../../models/conversations';
import ConversationCardsComponent from './conversation-cards.component';

interface Props {
    Height: number;
    ConversationCards: ConversationCardModel[];
    toggleCardActive: (id: ConversationCardModel, index: number) => void;
    scrollRef: React.MutableRefObject<any>;
}

const Card = ({ data, index, style }) => {
    const { cardData, toggleCardActive } = data;
    // let id = cardData[index]?.GroupChat?.ID ? cardData[index]?.GroupChat?.ID : UtilityService.unmaskPhoneNumber(cardData[index]?.PhoneNumber)
    let id = cardData[index]
    return (
        <ConversationCardsComponent
            // id={index}
            onClick={() => toggleCardActive(id, index)}
            style={style}
            data={cardData[index]}
            index={index}
        />
    );
}


const createCardData = (cardData: ConversationCardModel[], toggleCardActive: any) => ({
    cardData,
    toggleCardActive,
});

const ConversationInfiniteList = (props: Props) => {
    return (
        <AutoSizer>
            {({ width }) => (
                <List
                    ref={props.scrollRef}
                    className="List"
                    width={width}
                    height={props.Height}
                    itemCount={props.ConversationCards.length}
                    itemSize={75}
                    itemData={createCardData(props.ConversationCards, props.toggleCardActive)}
                // key={uniqueId()}
                >
                    {Card}
                </List>
            )}
        </AutoSizer>
    )
}

export default ConversationInfiniteList